import * as React from 'react';

import { Filters } from '../../components/Filters';
import { RegionSelectorContainer } from './RegionSelectorContainer';
import { DealTypeContainer } from './DealTypeContainer';
import { CategorySelectorContainer } from './CategorySelectorContainer';

export function FiltersContainer() {
  return (
    <Filters
      region={<RegionSelectorContainer />}
      dealType={<DealTypeContainer />}
      category={<CategorySelectorContainer />}
    />
  );
}
